export default {
    data: function () {
        return {
            service: '',
            reloadBus: null,
            afterLoad: null,
            defaultFilterFormModel: {
                page: 1,
                pageSize: 50
            },
            autoLoad: false,
            reloadInterval: 0,
            filterFormModel: {},
            items: [],
            itemCount: 0,
            reloadTimer: null,
            loading: false,
            listLoading: false
        }
    },
    methods: {
        load: function () {
            let loader = this.$loading.show();
            this.loading = true;
            this.listLoading = true;
            this.$service.get(this.service, {
                params: this.filterFormModel
            }).then(response => {
                this.apply(response.data);
            }).catch(error => {
                if (error.response.data.message) {
                    this.$swal({
                        text: error.response.data.message,
                        icon: 'error'
                    });
                }
            }).finally(() => {
                loader.hide();
                this.loading = false;
                this.listLoading = false;
                if(this.afterLoad){
                    this.afterLoad();
                }
            });
        },
        apply: function (data) {
            this.items = data.docs;
            this.itemCount = data.totalDocs;
        },
        reset: function () {
            this.filterFormModel = {};
            Object.assign(this.filterFormModel, this.defaultFilterFormModel);
            if (this.autoLoad) {
                this.load();
            }
        },
    },
    mounted: function () {
        this.filterFormModel = {};
        this.filterFormModel = Object.assign({}, this.filterFormModel, this.defaultFilterFormModel);
        if (this.autoLoad) {
            this.load();
        }
        if (this.reloadInterval > 0) {
            this.reloadTimer = setInterval(() => {
                this.$bgService.get(this.controller + '/' + this.actions.list, {
                    params: this.filterFormModel
                }).then(response => {
                    this.apply(response.data);
                });
            }, this.reloadInterval);
        }
        if (this.reloadBus) {
            this.$bus.$on(this.reloadBus, this.load);
        }
    },
    beforeDestroy: function () {
        if (this.reloadTimer != null) {
            clearInterval(this.reloadTimer);
        }
        if (this.reloadBus) {
            this.$bus.$off(this.reloadBus);
        }
    }
};